import axios from "axios";

import useMenusStore from "../store/menusStore";
import useCategoriesStore from "../store/categoriesStore";
import useItemsStore from "../store/itemsStore";


const useAdminAPI = () => {

    const { activeMenu, setActiveMenu, setMenus} = useMenusStore();
    const { setActiveCategory, setCategories, addCategory, updateCategory, deleteCategory } = useCategoriesStore();
    const { items, setItems, updateItem, deleteItem } = useItemsStore();

    // Fetch JWT from localStorage
    const getAuthToken = () => {
        return localStorage.getItem("token");
    };

    // Axios instance with Authorization header
    const axiosInstance = axios.create({
        baseURL: "/api",
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
        },
    });

    // Fetch all menus
    const fetchMenus = async () => {
        try {
            const response = await axiosInstance.get("/admin/menus");
            setMenus(response.data);
            setActiveMenu(response.data[0]);
        } catch (error) {
            console.error(error);
        }
    };

    // Fetch all categories
    const fetchCategories = async () => {
        try {
            const response = await axiosInstance.get("/admin/categories");
            setCategories(response.data);
            setActiveCategory(response.data[0]._id);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchItems = async () => {
        try {
            const response = await axiosInstance.get("/admin/items");
            setItems(response.data);
        } catch (error) {
            console.error(error);
        }
    }

    const addItemAPI = async (item) => {
        try {
            const response = await axiosInstance.post(`/admin/items`, {
                ...item,
            });
            setItems([...items, response.data]);
        } catch (error) {
            console.error(error);
        }
    }

    const deleteItemAPI = async (itemId) => {
        try {
            await axiosInstance.delete(`/admin/items/${itemId}`);
            deleteItem(itemId);
        } catch (error) {
            console.error(error);
        }
    }

    const updateItemAPI = async (item) => {
        try {
            //Pull __v from item object
            delete item.__v;
            const response = await axiosInstance.put(`/admin/items/${item._id}`, {
                ...item,
            });
            updateItem(item);
        } catch (error) {
            console.error(error);
        }
    }

    const addCategoryAPI = async (category) => {
        try {
            const response = await axiosInstance.post(`/admin/categories/${activeMenu._id}`, {
                ...category,
            });
            addCategory(response.data);
        } catch (error) {
            console.error(error);
        }
    }

    const deleteCategoryAPI = async (categoryId) => {
        try {
            await axiosInstance.delete(`/admin/categories/${categoryId}`);
            deleteCategory(categoryId);
        } catch (error) {
            console.error(error);
        }
    }

    const updateCategoryAPI = async (category) => {
        try {
            //Pull __v from category object
            delete category.__v;
            const response = await axiosInstance.put(`/admin/categories/${category._id}`, {
                ...category,
            });
            updateCategory(category);
        } catch (error) {
            console.error(error);
        }
    }

    return {
        fetchMenus,
        fetchCategories,
        fetchItems,
        addItemAPI,
        deleteItemAPI,
        updateItemAPI,
        addCategoryAPI,
        deleteCategoryAPI,
        updateCategoryAPI,
    }
};

export default useAdminAPI;
